/**
 * Ключи полки строк-подсказок (lib/goalShelf) и свёрнутых карточек (lib/goalFold) — отдельно
 * и без зависимостей: их стирает выход из аккаунта (UserProvider), которому не нужен разбор строк.
 */
export const GOAL_SHELF_KEY = "ach_goal_shelf_v1";
export const GOAL_FOLD_KEY = "ach_goal_fold_v1";

/** Выход: цели этого человека и его свёрнутые карточки не остаются в браузере следующему. */
export const clearGoalShelf = (): void => {
    try {
        localStorage.removeItem(GOAL_SHELF_KEY);
        localStorage.removeItem(GOAL_FOLD_KEY);
    } catch {
        /* хранилище закрыто — и полки нет */
    }
};
